// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"bcc87b01","113":"0e3f93a0","142":"4282b5c5","198":"7c41cc08","438":"baf467eb","498":"45627817","703":"3dbb21c4"}[chunkId] + ".chunk.js";
};